module.exports = __webpack_public_path__ + "static/media/map.3d996b36.png";